import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text/text';
import styles from './draft-discarded-note.module.scss';

export function DraftDiscardedNote(): ReactElement {
  return <Text val={window.i18next.t('pmwjs_ai_chat_draft_discarded')} size={TextSize.SM} className={styles.draftDiscardedNote} />;
}
